import React from 'react'
import { useTranslation } from 'react-i18next'

import { useLiveCountdown } from '@pages/RewardsHub/hooks/useTradingPoolProgress'

import { Display3, Heading6, Title2 } from '@ui/Typography'

import { CampaignsAvailableToJoinDto } from '@model/RewardsHubDashboardDto'

import { Box } from '@shared/components/Box'

export const TradingPoolAvailable: React.FC<{ campaign: CampaignsAvailableToJoinDto }> = ({
  campaign,
}) => {
  const daysRemaining = useLiveCountdown(campaign.tradingPool.drawDate)
  const { t } = useTranslation()

  return (
    <Box flex direction={'column'} gap='x12'>
      <Box>
        <Title2>{t('RewardsHub.TradingPool.Current Prize Pool')}</Title2>
        <Display3 semibold>${campaign.tradingPool.currentPrizePool}</Display3>
      </Box>

      <Box>
        <Title2>{t('RewardsHub.TradingPool.Draw in')}</Title2>
        <Heading6 semibold>{daysRemaining}</Heading6>
      </Box>
    </Box>
  )
}
